export default __webpack_public_path__ + "static/media/arrow-left.cc511791.svg";